import axios from "axios";
import { API_URL } from "@/config";
import { useSubscribeForFile } from "@/utils/useSubscribeForFile";

export default {
  namespaced: true,

  actions: {
    async getMany(_, criteria) {
      const response = await axios.get(`${API_URL}/returnRequests`, { params: criteria });

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async getOne(_, returnRequestId) {
      const response = await axios.get(`${API_URL}/returnRequests/${returnRequestId}`);

      if (!response.data || typeof response.data !== "object") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async accept(_, { returnRequestId, amount }) {
      const response = await axios.post(`${API_URL}/returnRequests/${returnRequestId}/accept`, {
        amount,
      });

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async bulkAccept(_, returnRequestsIds) {
      const response = await axios.post(`${API_URL}/returnRequests/bulkAccept`, {
        returnRequestsIds,
      });

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async cancel(_, returnRequestId) {
      const response = await axios.post(`${API_URL}/returnRequests/${returnRequestId}/cancel`);

      if (response.status !== 200 || !response.data.status) {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async create(_, returnRequestData) {
      const response = await axios.post(`${API_URL}/returnRequests/create`, returnRequestData);

      if (response.status !== 201 || !response.data || typeof response.data.id !== "number") {
        throw new Error("Error occurred while processing your request.");
      }

      return response.data;
    },

    async generateListExport({ commit, rootGetters }, criteria = {}) {
      const { subscribeForFile } = useSubscribeForFile(rootGetters, commit, true);

      await subscribeForFile("returnRequests/generateListExport", {
        url: `${API_URL}/returnRequests/generateListExport`,
        method: "POST",
        data: criteria,
      });
    },
  },
};
